// collection if commonly used icons
// TODO: maybe add all icons
// TODO: clean this up
export const icons = {
  add: 'fa-solid:plus',
  delete: 'fa6-solid:trash-can',
  user: 'fa-solid:user',
  external: 'fa6-solid:at',
  companyAccount: 'fa6-solid:building',
  search: 'fa-solid:search',
  close: 'fa6-solid:xmark',
  profile: 'fa6-solid:circle-user',
  settings: 'fa6-solid:gear',
  save: 'fa6-regular:file-lines',
  scheduled: 'fa6-solid:stopwatch',
  reminder: 'fa6-solid:bell',
  relates: 'fa6-solid:link',
  xls: 'ph:file-xls',
  chevronDown: 'fa6-solid:chevron-down',
  chevronUp: 'fa6-solid:chevron-up',
  bulletPoint: 'fa6-solid:minus',
  edit: 'fa-solid:pen',
  view: 'fa6-solid:eye',
  info: 'fa-solid:info-circle',
  link: 'fa-solid:link',
  publish: 'fa6-solid:paper-plane',
  icons: 'fa6-solid:icons',
  newsletter: 'fa6-solid:envelope-open-text'
};
